import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import StatsStrip from "@/components/StatsStrip";
import Courses from "@/components/Courses";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import EnquirySection from "@/components/EnquirySection";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain bg-[#031435] text-[#F4F4F0]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <StatsStrip />
        <Courses />
        <Manifesto />
        <Testimonials />
        <EditorialMarquee />
        <EnquirySection />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
